import React from 'react';
import { motion } from 'framer-motion';
import { SortMode } from '../types';
type Props = {
  sortMode: SortMode;
};
export const SortIndicator = ({ sortMode }: Props) => {
  const colorVariants = {
    on: {
      opacity: 1,
    },
    off: {
      opacity: 0.3,
    },
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="16"
      viewBox="0 0 7 16"
    >
      <motion.path
        initial={'off'}
        animate={sortMode === 'asc' ? 'on' : 'off'}
        variants={colorVariants}
        d="M0.553169 6.40036H5.84685C6.33882 6.40036 6.5846 5.6559 6.23763 5.22243L3.59179 1.80264C3.48367 1.6675 3.3424 1.59998 3.20121 1.59998C3.06012 1.59998 2.91943 1.6675 2.81223 1.80264L0.162373 5.22293C-0.184566 5.6554 0.061099 6.40036 0.553169 6.40036Z"
      />
      <motion.path
        initial={'off'}
        animate={sortMode === 'desc' ? 'on' : 'off'}
        variants={colorVariants}
        d="M6.2383 10.7775L3.59015 14.1977C3.48214 14.3328 3.34213 14.4003 3.20012 14.4003C3.05902 14.4003 2.91771 14.3327 2.8107 14.1975L0.162544 10.7773C-0.184656 10.345 0.0610382 9.59998 0.553167 9.59998H5.84748C6.33831 9.59998 6.58432 10.345 6.2383 10.7775Z"
      />
    </svg>
  );
};
